/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TemplateAttributeType = {
    FreeText: 'FREE_TEXT',
    PositiveIntegerNumber: 'POSITIVE_INTEGER_NUMBER',
    CompanyCapital: 'COMPANY_CAPITAL',
    DefaultRegistrationNumber: 'DEFAULT_REGISTRATION_NUMBER',
    TaxIdentificationNumber: 'TAX_IDENTIFICATION_NUMBER',
    RegistrationOfficeInformation: 'REGISTRATION_OFFICE_INFORMATION'
} as const;
export type TemplateAttributeType = typeof TemplateAttributeType[keyof typeof TemplateAttributeType];


export function instanceOfTemplateAttributeType(value: any): boolean {
    for (const key in TemplateAttributeType) {
        if (Object.prototype.hasOwnProperty.call(TemplateAttributeType, key)) {
            // @ts-ignore
            if (TemplateAttributeType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TemplateAttributeTypeFromJSON(json: any): TemplateAttributeType {
    return TemplateAttributeTypeFromJSONTyped(json, false);
}

export function TemplateAttributeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateAttributeType {
    return json as TemplateAttributeType;
}

export function TemplateAttributeTypeToJSON(value?: TemplateAttributeType | null): any {
    return value as any;
}

